module.exports = __webpack_public_path__ + "img/Quality Inspection_xuanzhong.436f3b99.png";